// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__2CDnr","content":"Hero_content__1jEBs","text":"Hero_text__r7sP2","buttonContainer":"Hero_buttonContainer__3s_bW"};